var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.03387,
    width: 8.98549,
    height: 8.98549,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5316 7.93854C11.7518 7.15875 11.7518 5.89446 12.5316 5.11467L16.0615 1.58484C16.8412 0.805053 18.1055 0.805053 18.8853 1.58484L22.4152 5.11467C23.1949 5.89446 23.1949 7.15875 22.4152 7.93854L18.8853 11.4684C18.1055 12.2482 16.8412 12.2482 16.0615 11.4684L12.5316 7.93854Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14.0145,
    width: 8.98549,
    height: 8.98549,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9807,
    y: 14.0145,
    width: 8.98549,
    height: 8.98549,
    rx: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabPattern);
export default __webpack_public_path__ + "static/media/tab-pattern.07a18fdcd9f524db7d85b1ede66e4814.svg";
export { ForwardRef as ReactComponent };